import styled from 'styled-components';
import {
  color,
  space,
  typography,
  layout,
  flexbox,
  border,
  position,
  shadow,
  grid,
  ColorProps,
  SpaceProps,
  TypographyProps,
  LayoutProps,
  FlexboxProps,
  BorderProps,
  PositionProps,
  ShadowProps,
  GridProps,
  compose
} from 'styled-system';
import InfiniteScroll from 'react-infinite-scroll-component';

export type ComposeType = ColorProps &
  SpaceProps &
  TypographyProps &
  LayoutProps &
  FlexboxProps &
  BorderProps &
  PositionProps &
  ShadowProps &
  GridProps;

export const Compose = compose(
  space,
  grid,
  color,
  layout,
  border,
  shadow,
  position,
  typography,
  flexbox
);
export const StyledDiv = styled.div<
  ComposeType & { direction?: string; gap?: string; cursor?: string }
>`
  direction: ${({ direction }): string | undefined => direction || 'inherit'};
  gap: ${({ gap }): string | undefined => gap}px;
  cursor: ${({ cursor }): string | undefined => cursor};
  ${Compose}
`;

export const StyledSpan = styled.span<ComposeType & { cursor?: string }>`
  cursor: ${({ cursor }): string | undefined => cursor};
  ${Compose};
`;

export const StyledError = styled.div`
  display: flex;
  justify-content: center;
  direction: rtl;
  align-items: center;
  height: 100px;
  color: ${({ theme }): string => theme.colors.danger};
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
`;

export const StyledInfiniteScroll = styled(InfiniteScroll)`
  overflow: unset !important;
`;

export const StyledBox = styled(StyledDiv)`
  width: 100%;
  min-height: 54px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  padding: 14px;
  position: relative;
  margin-bottom: ${({ type }): string => (type === 'message' ? '0' : '10px')};
`;
